import React, { FC } from 'react';
import { TypeEmptyDirectiveFields } from '@/core/generated-types';
import { InverseTextHero } from '../InverseTextHero';
import { DecorativeDivider, HeaderText, Image } from '@/components/ui';
import { UniversalCta } from '../UniversalCta';
import { HeaderSize } from '@/components/ui/HeaderText';

const Empty: FC<TypeEmptyDirectiveFields> = ({
  header,
  decorativeDivider,
  title,
  decorativeImage,
  description,
  cta,
}) => {
  return (
    <section data-testid="empty">
      {header && <InverseTextHero {...header.fields} />}
      {decorativeDivider && <DecorativeDivider {...decorativeDivider.fields} />}
      <div className="container mx-auto mt-8 lg:max-w-[1000px]">
        {title && <HeaderText text={title} size={HeaderSize.H3} />}
        {decorativeImage && (
          <Image
            imageData={decorativeImage}
            alt={decorativeImage?.fields.altText}
            className="mt-6 h-[6px] w-[54px] md:h-[13px] md:w-[121px]"
            width={121}
            height={13}
          />
        )}
        <p className="mt-6">{description}</p>
        {cta && <UniversalCta link={cta} className="mt-6 inline-flex" />}
      </div>
    </section>
  );
};

export default React.memo(Empty);
